import React from 'react';
import CheckboxInput from 'components/inputs/CheckboxInput';
import {
  ElementProps,
  CheckboxInputElementClass,
} from 'types/documentTemplateElement';
import {buildLabel, checkError} from 'utils/elementUtils';
import {useIsDocumentElementDisabled} from 'hooks/useIsDocumentElementDisabled';

interface CheckboxInputElementProps
  extends ElementProps<CheckboxInputElementClass> {}

const CheckboxInputElementComponent: React.FC<CheckboxInputElementProps> = ({
  element,
  updateElement,
  mode,
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (mode === 'view' || mode === 'admin') {
      const newUpdatedElement = new CheckboxInputElementClass({
        ...element,
        properties: {
          ...element.properties,
          value: e.target.checked,
        },
      });
      updateElement(newUpdatedElement);
    }
    return;
  };

  const disabled = useIsDocumentElementDisabled(element, mode);

  let containerClass = 'w-full mx-6 my-10';
  if (mode === 'view' || mode === 'preview' || mode === 'admin') {
    containerClass = element.properties.showLabel
      ? 'w-full mx-3 mb-2'
      : 'w-full mt-5 mx-3 mb-2';
  }

  return (
    <div className={containerClass}>
      <CheckboxInput
        id={element.id}
        label={buildLabel(element)}
        checked={!!element.properties?.value}
        error={checkError(element, mode)}
        required={element.properties.required}
        onChange={handleChange}
        disabled={disabled}
      />
    </div>
  );
};

export default CheckboxInputElementComponent;
